import React from 'react';
import { useIntl } from 'react-intl';
import { useFragment, graphql, useMutation } from 'react-relay/hooks';
import { Flexbox, Switch } from '@sonika-se/ui-kit/components';
export const EditEventIsCompensatoryTime = (props) => {
    const { eventRef } = props;
    const intl = useIntl();
    const { id, isCompensatoryTime } = useFragment(graphql `
      fragment EditEventIsCompensatoryTime_event on Event {
        id
        isCompensatoryTime
      }
    `, eventRef);
    const [updateEvent, updateEventLoading] = useMutation(graphql `
    mutation EditEventIsCompensatoryTimeMutation($model: UpdateEventRequestInput!) {
      updateEvent(model: $model) {
        eventEdge {
          node {
            id
            isCompensatoryTime
          }
        }
      }
    }
  `);
    return (<Flexbox align="center">
      <Switch disabled={updateEventLoading} checked={isCompensatoryTime} label={intl.formatMessage({
            id: 'EventSettings.IsCompensatoryTime',
            defaultMessage: 'Används som timbank',
        })} onChange={() => {
            updateEvent({
                variables: {
                    model: {
                        id,
                        isCompensatoryTime: !isCompensatoryTime,
                    },
                },
            });
        }}/>
    </Flexbox>);
};
export default EditEventIsCompensatoryTime;
